__webpack_require__.p = "/biscuit-paradise/";